<template>
  <div class="purchase-dialog">
    <Modal v-model="openPurchase" class-name="purchase-modal" :footer-hide="true" :closable="true">
      <h2 class="dia-title">
        WARNING
      </h2>
      <p class="intro">
        Participating in a live Art Blocks drop is for experts only. By submitting a transaction you acknowledge the
        following:
      </p>
      <ol class="notice">
        <li>You are competing with others.</li>
        <li>You might have to increase your gas price in order to have your transaction processed before others.</li>
        <li>
          Even with a high gas price it is possible your transaction will be confirmed AFTER the drop is sold out in
          which case your transaction will fail and you will lose the transaction fee for the failed transaction.
        </li>
      </ol>

      <p class="risk">
        PROCEED AT YOUR OWN RISK
      </p>

      <button class="purchaseBtn" @click="purchase">
        Purchase
      </button>
    </Modal>
  </div>
</template>

<script>
import { purchase } from '@/contactLogic/GenArt/index.js';
import { mapState } from 'vuex';
import event from '@/common/utils/event.js';
export default {
  data() {
    return {
      openPurchase: false,
      data: {},
    };
  },
  methods: {
    open(data) {
      console.log({ data });
      this.openPurchase = true;
      this.data = data;
    },
    async purchase() {
      try {
        const { library, account, chainID, projectId, pricePerTokenInWei,isPassport,passportId } = {
          library: this.ethersprovider,
          account: this.ethAddress,
          chainID: this.ethChainID,
          projectId: this.data.project_id,
          pricePerTokenInWei: this.data.token_info?.PricePerTokenInWei,
          isPassport: false,
          passportId: this.data.token_info?.PassportProjectId,
        };
        const res = await purchase({ library, account, chainID, projectId, pricePerTokenInWei,isPassport,passportId });
        console.log({ res });
        this.$Notice.success({
          title: 'Transaction sent successfully',
          duration: 10,
        });
        this.openPurchase = false;
        event.$emit('sendtx', [
          res,
          {
            okinfo: `Successful purchase`,
            failinfo: `Purchase failed`,
          },
        ]);
        // this.openPurchase = false;
      } catch (err) {
        console.log(err);
        this.$Notice.error({
          title: 'Failed to send transaction',
          desc: err?.error?.message,
          duration: 10,
        });
      }
    },
  },
  computed: {
    ...mapState(['ethersprovider', 'ethAddress', 'ethChainID']),
  },
};
</script>
<style lang="less" scoped>
.purchase-modal {
  color: #fff;
  .dia-title {
    text-align: center;
    margin-top: 20px;
    margin-bottom: 10px;
    font-size: 24px;
  }
  .intro {
    font-size: 16px;
  }
  .notice {
    font-size: 14px;
    padding-left: 15px;
    list-style: decimal inside;
    li {
      margin-top: 15px;
    }
  }
  .risk {
    margin-top: 12px;
    font-size: 16px;
    font-weight: 600;
  }
  .purchaseBtn {
    outline: none;
    cursor: pointer;
    font-size: 16px;
    margin-top: 30px;
    width: 100%;
    padding: 14px 0px;
    border-radius: 4px;
    background: rgb(119, 162, 211);
  }
}
</style>